import type { Organization, Reference } from '@medplum/fhirtypes'
import type { OrganizationAvailability } from '@seen/core/models/organizations/ExtendedOrganization'
import { Badge, cn, StarToggle } from '@seen/ui'
import { IconCheck } from '@tabler/icons-react'
import type { JSX } from 'react'
import { OrganizationNameplate } from '#src/components/nameplates/OrganizationNameplate.tsx'

export function OrganizationOption({
  organization,
  isSelected,
  faxNumber,
  availability,
}: {
  organization: Reference<Organization>
  isSelected?: boolean
  faxNumber?: string
  availability?: OrganizationAvailability
}): JSX.Element {
  return (
    <div className="flex flex-1 items-center justify-between gap-2">
      <span className="flex min-w-0 items-center">
        <OrganizationNameplate
          organization={organization}
          faxNumber={faxNumber}
        />
      </span>
      <span className="flex shrink-0 items-center gap-1.5">
        {availability === 'preferred' && (
          <StarToggle active label="Preferred organization" />
        )}
        {availability === 'available' && (
          <Badge variant="outline">Available</Badge>
        )}
        <IconCheck
          className={cn('mr-0.5 size-4 opacity-0', isSelected && 'opacity-100')}
        />
      </span>
    </div>
  )
}
